// Vendor
import React from 'react'

// WeSpire
import { Drawer } from 'components/ui/Drawer'

export default {
  argTypes: {
    children: {
      control: { type: 'text' },
      defaultValue: 'this is a Drawer component',
    },
  },
  component: Drawer,
  title: 'UI/Drawer',
}

const Template = (args) => <Drawer {...args} />

export const Drawer1 = Template.bind({})
Drawer1.args = {
  dataTest: 'test-drawer',
}
